import { TranslationsContext } from '@teliaee/telia-translate';
import { media, Button, Notice, Separator, Table } from 'telia-front-react';
import { inject, observer } from 'mobx-react';
import React from 'react';
import MediaQuery from 'react-responsive';
import RoamingStore from '../../stores/RoamingStore';
import { VasNumber } from '../RoamingInterfaces';
import {
  renderSpecialInformationDesktopTableHeading,
  renderSpecialInformationDesktopTableRow,
  renderSpecialInformationMobileTableRow
} from './RoamingSpecialAndEmergencyTableUtil';

interface SpecialNumbersProps {
  roamingStore?: RoamingStore;
}

const SpecialNumbers = (props: SpecialNumbersProps): JSX.Element => {
  const {
    roamingStore: {
      roamingBerecInformation,
      getCurrentlyDisplayedSpecialNumbers,
      selectedCountry,
      getAmountOfSpecialNumbersToLoadMore,
      shouldSliceDisplayedSpecialNumbers
    }
  } = props;
  const { translate } = React.useContext(TranslationsContext);

  const tableHeadingNumber = translate('roaming.berec.number');
  const tableHeadingNameDescription = translate('roaming.berec.name-or-description');
  const tableHeadingAdditionalInfo = translate('roaming.berec.additional-info');

  const getTableRowValues = (info: VasNumber): { [key: string]: string } => ({
    [tableHeadingNumber]: info.vasNumberRange,
    [tableHeadingNameDescription]: info.nameDescription,
    [tableHeadingAdditionalInfo]: info.additionalInformation
  });

  const getLoadMoreResultsButton = (): JSX.Element => {
    return shouldSliceDisplayedSpecialNumbers ? (
      <>
        <Separator spacing="xsmall" color="invisible" />
        <Button
          text={`${translate('roaming.berec.load-more')} (+${getAmountOfSpecialNumbersToLoadMore})`}
          size="small"
          onClick={() => props.roamingStore.handleLoadMoreSpecialNumbers()}
        />
      </>
    ) : null;
  };

  const renderSpecialNumbersDesktop = (items: VasNumber[]): JSX.Element => (
    <>
      <Table>
        <thead>
          {renderSpecialInformationDesktopTableHeading('special-number', [tableHeadingNumber, tableHeadingNameDescription, tableHeadingAdditionalInfo], 4)}
        </thead>
        <tbody>{items.map((info, index) => renderSpecialInformationDesktopTableRow(`special-number-${index}`, getTableRowValues(info), 4))}</tbody>
      </Table>
      {getLoadMoreResultsButton()}
    </>
  );

  const renderSpecialNumbersMobile = (items: VasNumber[]): JSX.Element => (
    <>
      <Table>{items.map((info, index) => renderSpecialInformationMobileTableRow(`special-number-${index}`, index, getTableRowValues(info)))}</Table>
      {getLoadMoreResultsButton()}
    </>
  );

  return (
    <>
      <Notice size="small">
        {selectedCountry.name}: {translate('roaming.berec.roaming-code')}
        <b>+{roamingBerecInformation.berecInformation.countryCode}</b>.
      </Notice>
      <Separator spacing="xsmall" color="invisible" />
      <MediaQuery minWidth={media.width.md.min}>
        {(matches) =>
          matches ? renderSpecialNumbersDesktop(getCurrentlyDisplayedSpecialNumbers) : renderSpecialNumbersMobile(getCurrentlyDisplayedSpecialNumbers)
        }
      </MediaQuery>
    </>
  );
};

export default inject('roamingStore')(observer(SpecialNumbers));
